import React, { Fragment } from 'react';
import ScrollLock from 'react-scrolllock';
import './instructions.css';
import mapview from '../../../../images/ParkingLots/Instructions/SF/mapview.jpeg';
import access from '../../../../images/ParkingLots/Instructions/SF/embarcadero.jpeg';
import elevator from '../../../../images/ParkingLots/Instructions/SF/elevator.jpeg';
import entry1 from '../../../../images/ParkingLots/Instructions/SF/entry1.jpeg';
import entry2 from '../../../../images/ParkingLots/Instructions/SF/entry2.png';
import machine from '../../../../images/ParkingLots/Instructions/SF/parkingmachine.jpeg';
import arrow1 from '../../../../images/ParkingLots/Instructions/SF/arrow1.jpg';
import arrow2 from '../../../../images/ParkingLots/Instructions/SF/arrow2.jpg';
import arrow3 from '../../../../images/ParkingLots/Instructions/SF/arrow3.jpg';
import arrow4 from '../../../../images/ParkingLots/Instructions/SF/arrow4.png';
import arrow5 from '../../../../images/ParkingLots/Instructions/SF/arrow5.jpg';
import arrow6 from '../../../../images/ParkingLots/Instructions/SF/arrow6.jpg';
import arrow7 from '../../../../images/ParkingLots/Instructions/SF/arrow7.jpg';
import ourcar1 from '../../../../images/ParkingLots/Instructions/SF/ourcar1.jpg';
import ourcar2 from '../../../../images/ParkingLots/Instructions/SF/ourcar2.jpg';
import { Helmet } from 'react-helmet';

const EmbarcaderoInstructions = () => (
  <Fragment>
    <Helmet>
      <title>Autzu | Parking Instructions</title>
      <meta
        name="description"
        content="Rent a car to drive and earn on ridesharing platforms with no upfront payments or term-commitments. From only $7/hour, we provide a pre-qualified car and include maintenance, insurance, parking and 24/7 roadside assistance."
      />
    </Helmet>
    <div className="instructions">
      <ScrollLock>
        <div className="instructions__container">
          <div className="instructions__title_container">
            <div className="instructions__title">
              Finding the Parking Hub
            </div>
            <div className="instructions__subtitle">
              <strong>3 Embarcadero Center</strong>
            </div>
          </div>
          <img className="instructions__image" src={mapview} />
          <div className="instructions__body">
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>How do I access the parking lot?</strong>
              </div>

              <p className="instructions__body-text">
                Autzu EV vehicles are parked in the Three Embarcadero
                Center underground parking facility at 3 Embarcadero Ctr,
                San Francisco, CA 94111
              </p>
              <p className="instructions__body-text">
                The parking location is a 3-minute walk from the
                Embarcadero BART and Muni stations.
              </p>
              <img className="instructions__image" src={access} />
            </div>
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot by walking?
                </strong>
              </div>
              <img className="instructions__image" src={elevator} />
              <p className="instructions__body-text">
                Enter 3 Embarcadero Center and walk to the dedicated
                parking elevators on the north side. Take either of the two
                parking elevators to parking <u>level A</u> and follow the
                Autzu signage to find the Autzu EV vehicles.
              </p>
            </div>
            <div className="instructions__body-section">
              <div className="instructions__body-title">
                <strong>
                  How do I access the parking lot by driving?
                </strong>
              </div>
              <div className="instructions__parellel-image">
                <img
                  className="instructions__smaller-image"
                  src={entry1}
                />
                <img
                  className="instructions__smaller-image"
                  src={entry2}
                />
              </div>
              <br />
              <p className="instructions__body-text">
                You can enter/exit the parking lot via Davis St or Drumm
                St. Tap the parking keycard attached to the Autzu vehicle
                sun visor to enter and exit the parking lot. The parking
                key card must <u>not</u> leave the Autzu vehicle at any
                point.
              </p>
              <img className="instructions__image" src={machine} />
              <p className="instructions__body-text">
                We do <u>not</u> currently offer free public parking for
                those who drive a personal vehicle to our hub. Please pay
                for parking if you are driving your personal vehicle to our
                location.
              </p>
              <br />
              <p className="instructions__body-text">
                Drivers will follow the arrows from the Davis st and Drumm
                st entrance ramps to the ramp to floor B
              </p>
              <br />
              <div className="instructions__parellel-image">
                <img
                  className="instructions__smaller-image"
                  src={arrow1}
                />
                <img
                  className="instructions__smaller-image"
                  src={arrow2}
                />
              </div>
              <br />
              <img className="instructions__image" src={arrow3} />
              <br />
              <p className="instructions__body-text">
                Drivers will then take a right at the bottom of the ramp
              </p>

              <img className="instructions__image" src={arrow4} />
              <br />
              <p className="instructions__body-text">
                Drivers will take 1 more immediate right turn
              </p>
              <img className="instructions__image" src={arrow5} />
              <br />
              <p className="instructions__body-text">
                and 2 left turns to the ramp upstairs
              </p>
              <div className="instructions__parellel-image">
                <img
                  className="instructions__smaller-image"
                  src={arrow6}
                />
                <img
                  className="instructions__smaller-image"
                  src={arrow7}
                />
              </div>
              <br />
              <p className="instructions__body-text">
                Our cars will be at the top of this ramp, labeled Autzu
                1-10
              </p>
              <img className="instructions__image" src={ourcar1} />
              <img className="instructions__image" src={ourcar2} />
            </div>
          </div>
        </div>
      </ScrollLock>
    </div>
  </Fragment>
);

export default EmbarcaderoInstructions;



// WEBPACK FOOTER //
// ./src/components/Static/ParkingLots/SF/EmbarcaderoInstructions.js